import React from 'react';
import '../HeroMobile.css';
import Navigation from './Navigation';

const Hero = () => {
  return (
    <section id="home" className="hero-section hero-typography">
      {/* Navigation Bar at the Top */}
      <Navigation />
      {/* Background Grid */}
      <div className="hero-grid-lines">
        <div className="grid-line"></div>
        <div className="grid-line"></div>
        <div className="grid-line"></div>
        <div className="grid-line"></div>
        <div className="grid-line"></div>
      </div>

      <div className="hero-container-typography">

        {/* Top Branding / Header Info */}
        <div className="hero-header-row">
          <div className="hero-brand-corner">
            <div className="brand-text">PORTFOLIO</div>
            <div className="brand-text">OF</div>
            <div className="brand-text bold">TEJEESH SAI</div>
            <div className="brand-text bold">REDDI</div>
          </div>
        </div>

        {/* Huge Typography Center */}
        <div className="hero-main-title">
          <div className="title-row condensed">FULL</div>
          <div className="title-row script-style">developer</div>
          <div className="title-row condensed">STACK</div>
        </div>

        {/* Note: User is a Full Stack Dev, but reference said UI/UX. 
            I will use the reference layout text but can adapt words. 
            Actually user said "make it like this", but they are a dev. 
            I'll stick to their role: "FULL STACK DEVELOPER" but using the layout.
        */}

      </div>

      {/* Decorative Shape Removed */}
    </section>
  );
};

export default Hero;